<template>
  <resource-search @delete="() => this.$emit('delete')" @input="id => this.$emit('input', id)" module="customers" :error-feed="errorFeed" :error-key="errorKey" :show-delete="showDelete" :wait-for-input="waitForInput" :fetch-params="extraFetchParams" v-model="value">
    <template #popover-list="{ result }">
      <p class="font-weight-bold mb-0  w-100-m-1">{{ result.forename }} {{ result.surname }}</p>
      <p class="text-muted text-truncate mb-0 w-100-m-1"><small>{{ result.email }}</small></p>
    </template>

    <template #selected="{ selected }">
      <p class="font-weight-bold mb-0  w-100-m-1">{{ selected.forename }} {{ selected.surname }}</p>
      <p class="text-muted text-truncate mb-0 w-100-m-1"><small>{{ selected.email }}</small></p>
    </template>
  </resource-search>
</template>

<script>
import ResourceSearch from './ResourceSearch.vue'

export default {
  components: { ResourceSearch },
  props: {
    showDelete: {
      type: Boolean,
      default: false,
    },
    waitForInput: {
      type: Boolean,
      default: true,
    },
    errorFeed: Object,
    errorKey: String,
    type: String,
    value: Object,
  },
  computed: {
    extraFetchParams() {
      if (this.type) {
        return { type: this.type };
      }

      return {};
    }
  }
}
</script>

<style>
  
</style>